//Mouseflow: la cola _mfq acepta comandos aunque el script todavia no haya cargado (el snippet de index.html usa defer),
//por eso se encola aqui en vez de llamar al global 'mouseflow', que puede no existir cuando el usuario actua rapido.
const push = (payload) => {
    try{
        window._mfq = window._mfq || [];
        window._mfq.push(payload);
    }catch(err){} //el tracking nunca debe romper el flujo de compra
}

export default {
    tag(name){ //etiqueta la sesion (un solo valor: para datos usar variable())
        push(["tag", String(name)]);
    },
    variable(key, value){ //par clave/valor filtrable en Mouseflow
        push(["setVariable", String(key), String(value)]);
    },
    pageView(path){ //vista virtual en SPA
        push(["newPageView", String(path)]);
    }
}
